module.exports = __webpack_public_path__ + "img/7.8bd64e89.jpg";